import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import { route } from "../../utils";
import { TranscriptionRequest, TranscriptionResponse } from "./types";

export * from "./types";

const ENDPOINTS = {
  TRANSCRIBE_AUDIO:
    "/api/v2/org/:organization_id/user/:user_id/audio-transcription",
};

export class AudioTranscriptionAPI {
  constructor(private client: CohesiveAPIClient) {}

  async transcribeAudio(
    audioBlob: Blob,
    options?: Omit<TranscriptionRequest, "file">,
    config?: AxiosRequestConfig,
  ): Promise<TranscriptionResponse> {
    const organizationId = await this.client.getOrgID();
    const userId = await this.client.getUserID();

    // Create FormData for file upload
    const formData = new FormData();

    // Create a file from the blob
    const audioFile = new File([audioBlob], "recording.webm", {
      type: audioBlob.type,
    });

    formData.append("file", audioFile);

    if (!options?.language) {
      formData.append("language", "en");
    }

    // Add optional parameters
    if (options?.model) {
      formData.append("model", options.model);
    } else {
      formData.append("model", "gpt-4o-transcribe");
    }

    if (options?.language) {
      formData.append("language", options.language);
    }

    if (options?.prompt) {
      formData.append("prompt", options.prompt);
    }

    if (options?.response_format) {
      formData.append("response_format", options.response_format);
    } else {
      formData.append("response_format", "json");
    }

    if (options?.temperature !== undefined) {
      formData.append("temperature", options.temperature.toString());
    }

    if (options?.timestamp_granularities) {
      options.timestamp_granularities.forEach((granularity) => {
        formData.append("timestamp_granularities[]", granularity);
      });
    }

    const response = await this.client.axios.post<TranscriptionResponse>(
      route(ENDPOINTS.TRANSCRIBE_AUDIO, {
        organization_id: organizationId,
        user_id: userId,
      }),
      formData,
      {
        ...config,
        headers: {
          ...config?.headers,
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return response.data;
  }
}
